export default __webpack_public_path__ + "static/media/lemon.4bc0fe7c.svg";